import { useCallback } from 'react'
import { useSelector } from '@/libs/state'
import { listOrgTeams } from '../application/list-departments'
import { orgTeams$, orgTeams as orgTeamsPort, notify } from '../wiring'

const useOrgTeams = () => {
	const teams = useSelector(orgTeams$)

	// reload is kept for callers that need a forced refresh after mutations
	const reload = useCallback(async () => {
		const result = await listOrgTeams(orgTeamsPort, notify)
		orgTeams$.set(result)
	}, [])

	return { teams, reload }
}

export { useOrgTeams }
